import { combineReducers } from 'redux';
import loadingReducer from './loading';
import modalReducer from './modal';
import snackbarReducer from './snackbar';
import loadingPageReducer from './loadingPage';

const uiReducer = combineReducers({
  loading: loadingReducer,
  loadingPage: loadingPageReducer,
  modal: modalReducer,
  snackbar: snackbarReducer,
});

export default uiReducer;
